import {AxiosResponse} from 'axios';

import {apiAxios} from 'IocContainer';
import {CheckoutSessionRequestPayload, ProSubscription} from 'shared/models/checkout';

class SubscriptionService {
  private static instance: SubscriptionService | null = null;

  public static getInstance(): SubscriptionService {
    if (!SubscriptionService.instance) {
      SubscriptionService.instance = new SubscriptionService();
    }
    return SubscriptionService.instance;
  }

  public async createCheckoutSession(companyId: string, payload: CheckoutSessionRequestPayload): Promise<string> {
    const response = await apiAxios.post<string>(`/companies/${companyId}/checkoutsession`, payload);
    return response.data;
  }

  public async generatePortalUrl(companyId: string, subscriptionId: string, returnUrl: string): Promise<string> {
    const response = await apiAxios.get<string>(
      `/companies/${companyId}/coresubscriptions/${subscriptionId}/portal_session?return_url=${returnUrl}`,
    );
    return response.data;
  }

  public async completeCheckoutSession(sessionId: string): Promise<ProSubscription> {
    const response = await apiAxios.post<ProSubscription>(`/checkoutsession/${sessionId}`);
    return response.data;
  }

  public async getSubscriptions(companyId: string): Promise<ProSubscription[]> {
    const response = await apiAxios.get<ProSubscription[]>(`/companies/${companyId}/coresubscriptions`);
    return response.data;
  }

  public async changeSubscriptionPlan(
    companyId: string,
    subscriptionId: string,
    priceId: string,
    quantity: number,
  ): Promise<ProSubscription[]> {
    const response = await apiAxios.post<ProSubscription[]>(
      `/companies/${companyId}/coresubscriptions/${subscriptionId}/changeplan?price_id=${priceId}&quantity=${quantity}`,
    );
    return response.data;
  }

  public async getProPlan(): Promise<any> {
    const response = await apiAxios.get('/proplans');
    return response.data[0];
  }

  public async cancelSubscription(
    companyId: string,
    subscriptionId: string,
    reason = '',
  ): Promise<AxiosResponse<void>> {
    return apiAxios.delete(`/companies/${companyId}/coresubscriptions/${subscriptionId}?note=${encodeURI(reason)}`);
  }
}

export const subscriptionService = SubscriptionService.getInstance();
